const site = {
  header: {
    title: 'Tweet Feed',
  },
  filter: {
    title: 'Filter by hashtag',
  },
  search: {
    placeholder: 'Search by keyword',
  },
  list: {
    cta: 'Load more',
  },
}

export default site